const API_URL = '';

const handleResponse = async (response) => {
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    if (response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('isAdminAuthenticated');
      window.location.href = '/admin/login';
    }
    throw new Error(error.message || 'An error occurred');
  }
  const data = await response.json();
  if (data.access_token) {
    localStorage.setItem('token', data.access_token);
    localStorage.setItem('isAdminAuthenticated', 'true');
  }
  return data;
};

const getHeaders = () => {
  const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  };
  const token = localStorage.getItem('token');
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
};

const fetchWithAuth = (url, options = {}) => {
  return fetch(`${API_URL}${url}`, {
    ...options,
    headers: getHeaders(),
    credentials: 'include'
  });
};

export const login = async (username, password) => {
  const response = await fetchWithAuth('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ username, password })
  });
  return handleResponse(response);
};

export const register = async (username, password) => {
  const response = await fetchWithAuth('/auth/register', {
    method: 'POST',
    body: JSON.stringify({ username, password })
  });
  return handleResponse(response);
};

// projects
export const getProjects = async () => {
  const response = await fetchWithAuth('/projects');
  return handleResponse(response);
};

export const createProject = async (projectData) => {
  const response = await fetchWithAuth('/projects', {
    method: 'POST',
    body: JSON.stringify(projectData)
  });
  return handleResponse(response);
};

export const updateProject = async (id, projectData) => {
  const response = await fetchWithAuth(`/projects/${id}`, {
    method: 'PUT',
    body: JSON.stringify(projectData)
  });
  return handleResponse(response);
};

export const deleteProject = async (id) => {
  const response = await fetchWithAuth(`/projects/${id}`, {
    method: 'DELETE'
  });
  return handleResponse(response);
};

// products
export const getProducts = async () => {
  const response = await fetchWithAuth('/products');
  return handleResponse(response);
};

export const createProduct = async (productData) => {
  const response = await fetchWithAuth('/products', {
    method: 'POST',
    body: JSON.stringify(productData)
  });
  return handleResponse(response);
};

export const updateProduct = async (id, productData) => {
  const response = await fetchWithAuth(`/products/${id}`, {
    method: 'PUT',
    body: JSON.stringify(productData)
  });
  return handleResponse(response);
};

export const deleteProduct = async (id) => {
  const response = await fetchWithAuth(`/products/${id}`, {
    method: 'DELETE'
  });
  return handleResponse(response);
};

// events
export const getEvents = async () => {
  const response = await fetchWithAuth('/events');
  return handleResponse(response);
};

export const createEvent = async (eventData) => {
  const response = await fetchWithAuth('/events', {
    method: 'POST',
    body: JSON.stringify(eventData)
  });
  return handleResponse(response);
};

export const updateEvent = async (id, eventData) => {
  const response = await fetchWithAuth(`/events/${id}`, {
    method: 'PUT',
    body: JSON.stringify(eventData)
  });
  return handleResponse(response);
};

export const deleteEvent = async (id) => {
  const response = await fetchWithAuth(`/events/${id}`, {
    method: 'DELETE'
  });
  return handleResponse(response);
};

// art
export const getArt = async () => {
  const response = await fetchWithAuth('/art');
  return handleResponse(response);
};

export const createArt = async (artData) => {
  const response = await fetchWithAuth('/art', {
    method: 'POST',
    body: JSON.stringify(artData)
  });
  return handleResponse(response);
};

export const updateArt = async (id, artData) => {
  const response = await fetchWithAuth(`/art/${id}`, {
    method: 'PUT',
    body: JSON.stringify(artData)
  });
  return handleResponse(response);
};

export const deleteArt = async (id) => {
  const response = await fetchWithAuth(`/art/${id}`, {
    method: 'DELETE'
  });
  return handleResponse(response);
};

// furniture
export const getFurniture = async () => {
  const response = await fetchWithAuth('/furniture');
  return handleResponse(response);
};

export const createFurniture = async (furnitureData) => {
  const response = await fetchWithAuth('/furniture', {
    method: 'POST',
    body: JSON.stringify(furnitureData)
  });
  return handleResponse(response);
};

export const updateFurniture = async (id, furnitureData) => {
  const response = await fetchWithAuth(`/furniture/${id}`, {
    method: 'PUT',
    body: JSON.stringify(furnitureData)
  });
  return handleResponse(response);
};

export const deleteFurniture = async (id) => {
  const response = await fetchWithAuth(`/furniture/${id}`, {
    method: 'DELETE'
  });
  return handleResponse(response);
}; 
